import { Component } from 'react';
import PropTypes from 'prop-types';
import datePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import ReactMaskedInput from 'react-text-mask';
import Input from '../Input';

/**
 * This component is a wrapper on [text-mask](https://www.npmjs.com/package/react-text-mask) ^5.4.3.
 * You can pass all props defined in the [docs](https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#keepcharpositions) plus all the custom props documented below.
 * If you want to use this component for dates, you can auto-enable date correction by providing createAutoCorrectedDatePipe prop with a proper date format
 * as described [here](https://github.com/text-mask/text-mask/tree/master/addons/#createautocorrecteddatepipe). When createAutoCorrectedDatePipe prop is provided
 * the pipe will be auto-attached and `keepCharPositions` prop will be set to `true`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
class MaskedInput extends Component {
  static propTypes = {
    /** User input in this configuration is passed through a pipe that auto-corrects some values.  */
    createAutoCorrectedDatePipe: PropTypes.string,
    /** If true selects input value on click */
    selectValueOnClick: PropTypes.bool,
    onClick: PropTypes.func
  };
  static defaultProps = {
    createAutoCorrectedDatePipe: undefined,
    selectValueOnClick: false,
    onClick: undefined
  };
  handleOnClick = event => {
    const {
      onClick,
      selectValueOnClick
    } = this.props;
    if (onClick) {
      onClick(event);
    }
    if (selectValueOnClick) {
      event.target.select();
    }
  };
  render() {
    // eslint-disable-next-line no-unused-vars
    const {
      createAutoCorrectedDatePipe,
      selectValueOnClick,
      ...rest
    } = this.props;
    if (createAutoCorrectedDatePipe) {
      rest.pipe = datePipe(createAutoCorrectedDatePipe);
      rest.keepCharPositions = true;
    }
    return /*#__PURE__*/_jsx(ReactMaskedInput, {
      guide: true,
      ...rest,
      render: (ref, props) => /*#__PURE__*/_jsx(Input, {
        onChange: this.handleChange,
        ...props,
        ref: ref,
        onClick: this.handleOnClick
      })
    });
  }
}
export default MaskedInput;